<template>
    <div class="">
        <section class="team-area four pt-100 pb-70">
            <div class="container">

                <div class="section-title">
                    <h2 v-if="!pgLoading">
                        {{ ($i18n.locale == 'en') ? items.en.title : items.ar.title }}
                    </h2>
                    <p v-if="!pgLoading"
                        v-html="($i18n.locale == 'en') ? items.en.body_striped : items.ar.body_striped">
                    </p>

                    <h2 v-if="pgLoading" class="webkit-animation col-4 offset-4 webkit-none-50"></h2>
                    <p v-if="pgLoading" class="webkit-animation col-6 offset-3 webkit-none-80"></p>
                </div>

                <div class="row" v-if="dataLoading">
                    <div v-for="(team, idx) in 3" :key="idx" class="col-sm-6 col-lg-4">
                        <div class="team-item webkit-animation webkit-410-470"></div>
                    </div>
                </div>

                <div class="row" v-if="!dataLoading">
                    <div v-for="(team, idx) in teams" :key="idx" class="col-sm-6 col-lg-4">
                        <div class="team-item">
                            <div class="top">
                                <img v-if="team.image" :src="team.image.url" :alt="team.en.title">
                                <ul>
                                    <li v-if="team.facebook">
                                        <a :href="team.facebook" target="_blank">
                                            <i class="icofont-facebook"></i>
                                        </a>
                                    </li>
                                    <li v-if="team.twitter">
                                        <a :href="team.twitter" target="_blank">
                                            <i class="icofont-twitter"></i>
                                        </a>
                                    </li>
                                    <li v-if="team.linkedin">
                                        <a :href="team.linkedin" target="_blank">
                                            <i class="icofont-linkedin"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="bottom">
                                <h3>{{ ($i18n.locale == 'en') ? team.en.title : team.ar.title }}</h3>
                                <span v-html="($i18n.locale == 'en') ? team.en.body_striped : team.ar.body_striped">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'OurTeam',
    components: {},
    data() {
        return {
            //
            items: [],
            teams: [],
            pgLoading: true,
            dataLoading: true,
            refs: 'front-settings/meet-our-excellent'
        }
    },
    mounted() { },
    created() {
        //
        this.fetchData();
        this.fetchTeams();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/' + this.refs,
                method: 'GET',
                data: {},
                headers: {
                    appId: process.env.VUE_APP_APPID
                },
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.items = res.data.data;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },

        fetchTeams() {
            this.dataLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/teamWorks',
                method: 'GET',
                data: {}
            }
            this.axios(options)
                .then(res => {
                    this.dataLoading = false;
                    this.teams = res.data.data.rows;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
